import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import App from './components/App';
import FunctionExposer from './components/FunctionExposer';
import GlobalProvider from './contexts/GlobalContext';
import loadFonts from './fonts';
import store from './store';
import "./i18n";
import 'swiper/css';
import 'swiper/css/pagination';
import './styles/index.scss';

loadFonts();

const renderApp = (selector, props) => {
  const rootElement = document.querySelector(selector);
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <Provider store={store}>
        <Router>
          <GlobalProvider>
            <FunctionExposer onReady={props.onReady} />
            <App {...props} />
          </GlobalProvider>
        </Router>
      </Provider>
    );
  }
};

const initGOSApp = (config) => {
  const { selector, onReady, ...props } = config;
  renderApp(selector, { onReady, ...props });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => renderApp("#root", {}));
} else {
  renderApp("#root", {});
}

window.initGOSApp = initGOSApp;
